import { Component, OnInit } from '@angular/core';
import { IntegratedAdmissionRegularWizardService } from '../service/integrated-admission-regular.wizard.service';
import { IntegratedAdmissionWizardService } from '../service/integrated-admission-wizard.service';
import { InvoiceCashDeskService } from 'src/app/services/invoice-cash-desk/invoice-cash-desk.service';
import { InvoiceIntegratedAdmissionCashDeskService } from 'src/app/services/invoice-cash-desk/invoice-integrated-admission-cash-desk.service';

@Component({
  selector: 'app-integrated-regular-admission-wizard',
  providers: [
    {
      provide: IntegratedAdmissionWizardService,
      useClass: IntegratedAdmissionRegularWizardService,
    },
    {
      provide: InvoiceCashDeskService,
      useClass: InvoiceIntegratedAdmissionCashDeskService,
    },
  ],
  templateUrl: './integrated-regular-admission-wizard.component.html',
  styleUrls: ['./integrated-regular-admission-wizard.component.css']
})
export class IntegratedRegularAdmissionWizardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
